export default __webpack_public_path__ + "static/title-news-ko-92dab926e6793187d435f959bd724686.png";